import React from 'react';

const Header = () => {
  return (
    <>
      <table width="100%" border="0" cellSpacing="0" cellPadding="0">
        <tbody>
          <tr>
            <td style={{ width: '150px', verticalAlign: 'top' }}>
              <img
                src="/Images/miahandsonslogo.png"
                alt="Miah & Sons Industries Ltd."
                style={{ width: '135px' }}
              />
            </td>
            <td style={{ verticalAlign: 'top', paddingLeft: '10px' }}>
              <div style={{ fontSize: '25px', fontWeight: 'bold', color: '#161515ac', lineHeight: '32px' }}>
                MIAH &amp; SONS INDUSTRIES LIMITED.
              </div>
              <div style={{ fontSize: '13px', lineHeight: '19px', marginTop: '4px' }}>
                <strong>Factory Address:</strong> Holding No : 110/01, Mouza: Barabo, PO. Shakaswar, P.S. Kaliakoir,<br />
                Gazipur-1703, Bangladesh. Mobile No: 01711-564795, 01866-990720<br />
                <span style={{ color: '#d2691e' }}>
                  <strong>E-mail:</strong> miahandsons@gmail.com
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <hr style={{ border: 'none', borderTop: '1px solid #000', margin: '8px 0 15px' }} />
    </>
  );
};

export default Header;